import React, { useState } from 'react'
import { Route, Routes } from 'react-router-dom';
import ReturnRefund from '../pages/burger/ReturnRefund'; 
import PrivacyPolicy from '../pages/burger/PrivacyPolicy'; 
import Eula from '../pages/burger/Eula'; 
import Home from '../pages/home/index';
import FAQs from '../pages/burger/Faqs'; 
import TermsConditions from '../pages/burger/TermsCondition';
import PublicLayout from '../layout/PublicLayout';
import EventPage from "../pages/event/eventPage"; 
import TyPage from '../pages/transaction/TyPage';
import Ty from '../pages/transaction/Ty';
import Confirmation from '../pages/transaction/Confirmation';

const PublicRoute = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route path="/" element={<PublicLayout />}>
                    <Route index element={<Home />} />
                     <Route path="/faqs" element={<FAQs />} />
                    {/* <Route path="/support" element={<Support />} /> */}
                    <Route path="/terms-and-conditions" element={<TermsConditions />} />
                    <Route path="/end-user-license-agreement" element={<Eula />} />
                    <Route path="/return-refund-policy" element={<ReturnRefund />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    {/* <Route path="/event/:id" element={<EventPage />} /> */}
                    <Route path="/event/:slug" element={<EventPage />} />
                    <Route path="/transactions" element={<Ty />} />
                    <Route path="/transaction" element={<TyPage />} />
                    <Route path="/confirmation" element={<Confirmation />} />
                </Route>
            </Routes>
        </React.Fragment>
    )
}

export default PublicRoute